import PropTypes from 'prop-types'

import AttackTypeIcon from 'components/common/AttackTypeIcon'
import GlyphIcon from 'components/common/GlyphIcon'
import { getNextScheduled } from 'components/navigation/Notifications/utils'
import useScenarioScheduleDetails from 'hooks/use-scenario-schedule-details'

import AttackRow, {
  AttackDescription,
  DetailsChevron
} from './common/AttackRow'

export default function ScheduledScenarioRow({ schedule }) {
  const { trigger, scenario_id } = schedule
  const { name, commandType } = useScenarioScheduleDetails(scenario_id)

  return (
    <AttackRow
      data-scheduled-scenario-row
      css={{
        gridTemplateColumns: '1fr 24px'
      }}
      to={`/scenarios/detail/${scenario_id}`}
    >
      <AttackDescription
        description={getNextScheduled(trigger)}
        icon={
          <GlyphIcon>
            <AttackTypeIcon icon={commandType} />
          </GlyphIcon>
        }
        name={name}
      />
      <DetailsChevron />
    </AttackRow>
  )
}

ScheduledScenarioRow.propTypes = {
  schedule: PropTypes.object
}
